import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updateVisitVideos = async ({
  visitId,
  patientId,
  sessionId,
  stepId,
  appVideos,
  isAllVideos,
  disallowInvVideosSelection,
  applyVideosToFollowing,
}) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (patientId) params.append("patient_id", patientId);
  if (sessionId) params.append("session_id", sessionId);
  if (stepId) params.append("step_id", stepId);

  const payload = { app_videos: appVideos };
  if (isAllVideos !== undefined) payload.is_all_videos = isAllVideos;
  if (disallowInvVideosSelection !== undefined)
    payload.disallow_inv_videos_selection = disallowInvVideosSelection;
  if (applyVideosToFollowing !== undefined)
    payload.apply_videos_to_following = applyVideosToFollowing;

  const res = await axios.put(
    `${__API_URL__}/api/photos/visits/${visitId}/videos/?${params.toString()}`,
    payload,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdateVisitVideosMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateVisitVideos,
    onSuccess: (_, variables) => {
      toast.success("Videos updated");
      queryClient.invalidateQueries({ queryKey: ["visit_videos", variables.visitId] });
      queryClient.invalidateQueries({ queryKey: ["visits"] });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update videos");
    },
  });
};

export default useUpdateVisitVideosMutation;
